import React from 'react';

import S from 'app/components/Image/Placeholder/Placeholder.styled';

const Placeholder = () => (
  <S.Placeholder>
    <S.Placeholder.SvgError
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      data-t="error-svg"
      aria-labelledby="error-svg"
      role="img"
    >
      <title id="error-svg">Error</title>
      <path d="M12.05 17.98l.9 2.7A1 1 0 0112 22a1 1 0 01-.95-.68l-.9-2.7a1.85 1.85 0 00-2.33-1.17l-2.7.9a1 1 0 01-.64-1.9l2.7-.9a3.85 3.85 0 014.87 2.43zm9.9-6.3a1 1 0 01-.63 1.27l-2.7.9a1.85 1.85 0 00-1.17 2.33l.9 2.7a1 1 0 01-.95 1.32 1 1 0 01-.95-.68l-.9-2.7a3.85 3.85 0 012.43-4.87l2.7-.9a1 1 0 011.27.63zm-13.5-4.5a3.85 3.85 0 01-2.43 4.87l-2.7.9a1 1 0 01-1.27-.63 1 1 0 01.63-1.27l2.7-.9a1.85 1.85 0 001.17-2.33l-.9-2.7a1 1 0 111.9-.64l.9 2.7zm3.5-1.16l-.9-2.7a1 1 0 01.63-1.27 1 1 0 011.27.63l.9 2.7a1.85 1.85 0 002.33 1.17l2.7-.9a1 1 0 01.64 1.9l-2.7.9a3.83 3.83 0 01-1.22.2 3.85 3.85 0 01-3.65-2.63z" />
    </S.Placeholder.SvgError>
  </S.Placeholder>
);

export default Placeholder;
